const projectsData = {
  data: [
    {
      background_color: '#00CC66',
      desktop_image: 'https://i.imgur.com/21XEnJI.jpg',
      project_url: 'https://www.youtube.com/watch?v=t7NTVQzXiLg',
      mobile_image: '',
      title: 'About Me',
      github_url: '',
      tagline: 'Otaku Audiophile Bookworm Engineer',
      role: `My name's Simon Chan and I'm doing my best everyday to be a decent person. I love collecting books that I never read, listening to music, cup ramen and my family. As a software developer, I hope to make applications that will help unlock opportunities for motivated people.`,
      tech_stack: ['Javascript', 'Node.js', 'React.js', 'Redux', 'SQL', 'Python', 'Fullstack', 'Japanese', 'Portapros', 'Books', 'Noodles', 'Family']
    },
    {
      background_color: '#25adff',
      desktop_image: 'https://i.imgur.com/hjoxlB7.png',
      mobile_image: '',
      title: 'Puyostone',
      date: '2017',
      github_url: 'https://github.com/puyo-stone/puyo-stone',
      demo: 'https://youtu.be/EKemdnyTqa8',
      project_url: 'https://puyost.one/',
      tagline: `React/Redux-based recreation of Sega's Puyo Puyo`,
      background: 'Puyo-stone is a recreation of the classic Sega Japaneze puzzle game Puyo Puyo',
      role: `I designed the majority of the game's UI using CSS grid for the layout and implemented a graphics engine using d3 to render the elements of the game. I co-developed the game logic and physics such as collision detection and managing the flag system which was implemented through Redux.`,
      tech_stack: ['React.js', 'Redux', 'Firebase', 'Webpack', 'd3.js', 'Puyo']
    },
    {
      background_color: 'rgb(255,47,47)',
      desktop_image: 'https://i.imgur.com/tvTQlUJ.png',
      title: 'Curly',
      date: '2017',
      mobile_image: '',
      github_url: 'https://github.com/bluufish/Clover',
      project_url: 'https://youtu.be/PF1neoB4Tqk',
      tagline: 'A React Japanese Language repl',
      background: 'Curly is a Japanese language translation shell styled after repl.it to assist coders in learning a non coding language',
      role: 'Curly was built during a two day hackathon at Fullstack Academy and was my first dive into using third party API. I experienced many difficultes dealing with multiple CORS issues which I solved by learning more about how client server requests work and building out a back end and having my express server make the requests then serve them to the client.',
      tech_stack: ['React.js', 'express', 'Node.js', 'Japanese']
    },
    {
      background_color: '#7300e6',
      desktop_image: 'https://i.imgur.com/XGbOd2k.png',
      mobile_image: '',
      title: 'Calorie Cart',
      date: '2017',
      github_url: 'https://github.com/graceshopper-spaxs/gshopper',
      project_url: 'https://calorie-cart.herokuapp.com/',
      tagline: 'Your one stop React shop for potatoes',
      background: 'This was an experiment in recursion and graph databases using the Twitter API.',
      role: 'I designed multiple reusable React components such as the cart view that made our code very DRY. By creating a reusable presentational cart component, I later easily implemented an order history feature which simply renders the old purchases using the cart component. On the backend I wrote RESTful API routes using express and Sequelize for retrieving past orders. Anither reusable components I wrote was a higher order button which could change its dispatch action depending on what props were passed down.',
      tech_stack: ['React.js', 'Redux', 'SQL', 'express', 'Node.js', 'Potato']
    },
  ]
};

export { projectsData };





// WEBPACK FOOTER //
// ./src/data/projects.js